export default function MerchantOperatingHoursMobileHeader({ title }) {
  return (
    <header className="-mx-4 bg-merchant-input px-4 py-3.5">
      <h1 className="text-base font-bold text-merchant-ink">{title}</h1>
    </header>
  )
}
